// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-card.danger {
  color: var(--primary-color-dark);
  background-color: var(--primary-color-main-transparent-25);
}`, "",{"version":3,"sources":["webpack://./src/components/common/parts/InfoCard.scss"],"names":[],"mappings":"AACC;EACC,gCAAA;EACA,0DAAA;AAAF","sourcesContent":[".info-card {\r\n\t&.danger{\r\n\t\tcolor: var(--primary-color-dark);\r\n\t\tbackground-color: var(--primary-color-main-transparent-25);\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
